import { useEffect, useState } from "react";
import CRMService from "../../services/crm.service";

export default function ReservationNotes({ reservationId }) {
  const [open, setOpen] = useState(false);
  const [record, setRecord] = useState(null);
  const [draft, setDraft] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setRecord(null); setError("");
    CRMService.getReservationNotes(reservationId).then(({ data }) => {
      if (active) { setRecord(data); setDraft(data.internal_notes || ""); }
    }).catch(() => { if (active) setError("Unable to load notes. Close and reopen to retry."); });
    return () => { active = false; };
  }, [open, reservationId]);
  const save = async () => {
    setSaving(true); setError("");
    try {
      const { data } = await CRMService.saveReservationNotes(reservationId, {
        internal_notes: draft, updated_at: record.updated_at,
      });
      setRecord(data); setOpen(false);
    } catch (err) {
      setError(err.response?.status === 409
        ? "Someone else updated these notes. Copy your changes, then close and reopen before saving."
        : "Unable to save notes. Your changes are still here; please try again.");
    } finally { setSaving(false); }
  };
  if (!reservationId) return null;
  return <div className="uk-margin-small-top">
    <button className="uk-button uk-button-default uk-button-small" type="button"
      aria-expanded={open} onClick={() => setOpen(!open)} disabled={saving}>Internal notes</button>
    {open && <div className="uk-margin-small-top">
      <p>Notes for this reservation only. Visible to your team.</p>
      {error && <p role="alert">{error}</p>}
      {!record && !error && <p role="status">Loading notes…</p>}
      {record && <>
        <label className="uk-form-label" htmlFor={`reservation-notes-${reservationId}`}>Internal notes</label>
        <textarea id={`reservation-notes-${reservationId}`} className="uk-textarea" rows={5}
          maxLength={20000} value={draft} disabled={saving} onChange={(e) => setDraft(e.target.value)} />
        <div className="uk-margin-small-top">
          <button type="button" className="uk-button hms-btn hms-red-btn uk-button-small"
            disabled={saving} onClick={save}>{saving ? "Saving…" : "Save notes"}</button>{" "}
          <button type="button" className="uk-button uk-button-default uk-button-small"
            disabled={saving} onClick={() => setOpen(false)}>Cancel</button>
        </div>
      </>}
    </div>}
  </div>;
}
